import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LayerPanel } from 'components/minute/controls/LayerPanel';
import { motion } from 'framer-motion';
import {
    ANIMATION_BIGGER,
    ANIMATION_SMALLER,
    conditionalScaleAnimation
} from 'libs/styles/animations';
import { EBorders, EFonts, EHovers } from 'libs/styles/styling';
import { useContext, useState } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MarkersListControl = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const [showList, setShowList] = useState(false);

    return (
        <S_MarkersListControl className={props.className}>
            <S_Header
                $isOpen={showList}
                onClick={() => {
                    setShowList((curr) => !curr);
                }}
            >
                <S_Left>
                    <S_Icon icon={['fal', 'layer-group']} />
                    <S_Text>
                        {Localization.MARKERS} {showList && <>({ctxEdit.worldMarkers?.length})</>}
                    </S_Text>
                </S_Left>
                <motion.div
                    {...conditionalScaleAnimation(true, ANIMATION_BIGGER, ANIMATION_SMALLER)}
                >
                    <S_Button>
                        <S_Icon icon={['fal', showList ? 'xmark' : 'angle-down']} />
                    </S_Button>
                </motion.div>
            </S_Header>
            {showList && <LayerPanel />}
        </S_MarkersListControl>
    );
};

const S_MarkersListControl = styled.div`
    position: absolute;
    top: 70px;
    left: 15px;
    z-index: 1;
    display: flex;
    flex-direction: column;
    user-select: none;
    border: 1px solid ${EBorders.DARK};
    border-radius: 7px;
`;

const S_Header = styled.div<{ $isOpen: boolean }>`
    width: ${(props) => (props.$isOpen ? '250px' : '157px')};
    background: #efefef;
    align-items: center;
    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.1);
    padding: 5px 11px;
    border-radius: ${(props) => (props.$isOpen ? '7px 7px 0 0' : '7px')};
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    &:hover {
        box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.1), ${EHovers.LIGHT4};
    }
`;

const S_Left = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 20px;
    color: #141c54;
    width: 30px;
`;

const S_Button = styled.div`
    width: 30px;
    height: 30px;
    display: flex;
    color: #e6e6e6;
    justify-content: right;
    align-items: center;
    margin-left: auto;
`;

const S_Text = styled.div`
    font-size: 13px;
    margin-left: 13px;
    font-family: ${EFonts.Regular};
    color: #141c54;
`;
